// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ISecurityItem {
  /** Тип безопасности **/
  type: EType;
  /** Значение **/
  title: string;
}

export enum EType {
  /** Огороженный периметр **/
  'Perimetr' = 'perimetr',
  /** Видеонаблюдение **/
  'Camera' = 'camera',
  /** Пропускная система **/
  'Access' = 'access',
  /** Противопожарная система **/
  'Fire' = 'fire',
  /** Круглосуточная охрана **/
  'AroundTheClock' = 'aroundTheClock',
  /** Консьерж **/
  'Concierge' = 'concierge',
  /** Охраняемая парковка **/
  'Parking' = 'parking',
  /** Сигнализация **/
  'Signal' = 'signal',
}
